export const HOME = {
  emergentLink: "home-emergent-link",
  ctaStartDesigning: "cta-start-designing",
  ctaViewDemo: "cta-view-demo",
  navLogo: "nav-logo",
};

export const SHOWROOM = {
  root: "showroom-root",
  finishSelector: (id) => `finish-${id}`,
  hotspot: (slot) => `hotspot-${slot}`,
  slotImage: (slot) => `slot-image-${slot}`,
  modelPanelClose: "model-panel-close",
  modelChoice: (id) => `model-choice-${id}`,
  reset: "showroom-reset",
  share: "showroom-share",
  exportPng: "showroom-export-png",
  exportPdf: "showroom-export-pdf",
  totalPrice: "showroom-total",
  shareLink: "share-link-input",
  cabinetChip: (finish) => `cabinet-chip-${finish}`,
  summaryItem: (slot) => `summary-item-${slot}`,
};
